/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './__root'
import { Route as SubscriptionsRouteImport } from './subscriptions'
import { Route as ProfileRouteImport } from './profile'
import { Route as MarketplaceRouteImport } from './marketplace'
import { Route as HistoryRouteImport } from './history'
import { Route as DashboardRouteImport } from './dashboard'
import { Route as BulkRouteImport } from './bulk'
import { Route as ApiRouteImport } from './api'
import { Route as AccountRouteImport } from './account'
import { Route as AuthRouteImport } from './_auth'
import { Route as IndexRouteImport } from './index'
import { Route as SourcesIndexRouteImport } from './sources/index'
import { Route as CollectionsIndexRouteImport } from './collections/index'
import { Route as SourcesSourceIdRouteImport } from './sources/$sourceId'
import { Route as ShareTokenRouteImport } from './share.$token'
import { Route as ResourcesResourceIdRouteImport } from './resources.$resourceId'
import { Route as CollectionsCollectionIdRouteImport } from './collections/$collectionId'
import { Route as ChannelsChannelIdRouteImport } from './channels.$channelId'
import { Route as AuthSignupRouteImport } from './_auth.signup'
import { Route as AuthResetPasswordRouteImport } from './_auth.reset-password'
import { Route as AuthLoginRouteImport } from './_auth.login'
import { Route as AuthForgotPasswordRouteImport } from './_auth.forgot-password'

const SubscriptionsRoute = SubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./subscriptions.lazy').then((d) => d.Route))
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./profile.lazy').then((d) => d.Route))
const MarketplaceRoute = MarketplaceRouteImport.update({
  id: '/marketplace',
  path: '/marketplace',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./marketplace.lazy').then((d) => d.Route))
const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./history.lazy').then((d) => d.Route))
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./dashboard.lazy').then((d) => d.Route))
const BulkRoute = BulkRouteImport.update({
  id: '/bulk',
  path: '/bulk',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./bulk.lazy').then((d) => d.Route))
const ApiRoute = ApiRouteImport.update({
  id: '/api',
  path: '/api',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./api.lazy').then((d) => d.Route))
const AccountRoute = AccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./account.lazy').then((d) => d.Route))
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./_auth.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./index.lazy').then((d) => d.Route))
const SourcesIndexRoute = SourcesIndexRouteImport.update({
  id: '/sources/',
  path: '/sources/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./sources/index.lazy').then((d) => d.Route))
const CollectionsIndexRoute = CollectionsIndexRouteImport.update({
  id: '/collections/',
  path: '/collections/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./collections/index.lazy').then((d) => d.Route))
const SourcesSourceIdRoute = SourcesSourceIdRouteImport.update({
  id: '/sources/$sourceId',
  path: '/sources/$sourceId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./sources/$sourceId.lazy').then((d) => d.Route))
const ShareTokenRoute = ShareTokenRouteImport.update({
  id: '/share/$token',
  path: '/share/$token',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./share.$token.lazy').then((d) => d.Route))
const ResourcesResourceIdRoute = ResourcesResourceIdRouteImport.update({
  id: '/resources/$resourceId',
  path: '/resources/$resourceId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./resources.$resourceId.lazy').then((d) => d.Route),
)
const CollectionsCollectionIdRoute = CollectionsCollectionIdRouteImport.update({
  id: '/collections/$collectionId',
  path: '/collections/$collectionId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./collections/$collectionId.lazy').then((d) => d.Route),
)
const ChannelsChannelIdRoute = ChannelsChannelIdRouteImport.update({
  id: '/channels/$channelId',
  path: '/channels/$channelId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./channels.$channelId.lazy').then((d) => d.Route))
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./_auth.signup.lazy').then((d) => d.Route))
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./_auth.reset-password.lazy').then((d) => d.Route))
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./_auth.login.lazy').then((d) => d.Route))
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any).lazy(() =>
  import('./_auth.forgot-password.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/api': typeof ApiRoute
  '/bulk': typeof BulkRoute
  '/dashboard': typeof DashboardRoute
  '/history': typeof HistoryRoute
  '/marketplace': typeof MarketplaceRoute
  '/profile': typeof ProfileRoute
  '/subscriptions': typeof SubscriptionsRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/signup': typeof AuthSignupRoute
  '/channels/$channelId': typeof ChannelsChannelIdRoute
  '/collections/$collectionId': typeof CollectionsCollectionIdRoute
  '/resources/$resourceId': typeof ResourcesResourceIdRoute
  '/share/$token': typeof ShareTokenRoute
  '/sources/$sourceId': typeof SourcesSourceIdRoute
  '/collections': typeof CollectionsIndexRoute
  '/sources': typeof SourcesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account': typeof AccountRoute
  '/api': typeof ApiRoute
  '/bulk': typeof BulkRoute
  '/dashboard': typeof DashboardRoute
  '/history': typeof HistoryRoute
  '/marketplace': typeof MarketplaceRoute
  '/profile': typeof ProfileRoute
  '/subscriptions': typeof SubscriptionsRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/signup': typeof AuthSignupRoute
  '/channels/$channelId': typeof ChannelsChannelIdRoute
  '/collections/$collectionId': typeof CollectionsCollectionIdRoute
  '/resources/$resourceId': typeof ResourcesResourceIdRoute
  '/share/$token': typeof ShareTokenRoute
  '/sources/$sourceId': typeof SourcesSourceIdRoute
  '/collections': typeof CollectionsIndexRoute
  '/sources': typeof SourcesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/account': typeof AccountRoute
  '/api': typeof ApiRoute
  '/bulk': typeof BulkRoute
  '/dashboard': typeof DashboardRoute
  '/history': typeof HistoryRoute
  '/marketplace': typeof MarketplaceRoute
  '/profile': typeof ProfileRoute
  '/subscriptions': typeof SubscriptionsRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/signup': typeof AuthSignupRoute
  '/channels/$channelId': typeof ChannelsChannelIdRoute
  '/collections/$collectionId': typeof CollectionsCollectionIdRoute
  '/resources/$resourceId': typeof ResourcesResourceIdRoute
  '/share/$token': typeof ShareTokenRoute
  '/sources/$sourceId': typeof SourcesSourceIdRoute
  '/collections/': typeof CollectionsIndexRoute
  '/sources/': typeof SourcesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account'
    | '/api'
    | '/bulk'
    | '/dashboard'
    | '/history'
    | '/marketplace'
    | '/profile'
    | '/subscriptions'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/channels/$channelId'
    | '/collections/$collectionId'
    | '/resources/$resourceId'
    | '/share/$token'
    | '/sources/$sourceId'
    | '/collections'
    | '/sources'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account'
    | '/api'
    | '/bulk'
    | '/dashboard'
    | '/history'
    | '/marketplace'
    | '/profile'
    | '/subscriptions'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/channels/$channelId'
    | '/collections/$collectionId'
    | '/resources/$resourceId'
    | '/share/$token'
    | '/sources/$sourceId'
    | '/collections'
    | '/sources'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/account'
    | '/api'
    | '/bulk'
    | '/dashboard'
    | '/history'
    | '/marketplace'
    | '/profile'
    | '/subscriptions'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_auth/signup'
    | '/channels/$channelId'
    | '/collections/$collectionId'
    | '/resources/$resourceId'
    | '/share/$token'
    | '/sources/$sourceId'
    | '/collections/'
    | '/sources/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AccountRoute: typeof AccountRoute
  ApiRoute: typeof ApiRoute
  BulkRoute: typeof BulkRoute
  DashboardRoute: typeof DashboardRoute
  HistoryRoute: typeof HistoryRoute
  MarketplaceRoute: typeof MarketplaceRoute
  ProfileRoute: typeof ProfileRoute
  SubscriptionsRoute: typeof SubscriptionsRoute
  ChannelsChannelIdRoute: typeof ChannelsChannelIdRoute
  CollectionsCollectionIdRoute: typeof CollectionsCollectionIdRoute
  ResourcesResourceIdRoute: typeof ResourcesResourceIdRoute
  ShareTokenRoute: typeof ShareTokenRoute
  SourcesSourceIdRoute: typeof SourcesSourceIdRoute
  CollectionsIndexRoute: typeof CollectionsIndexRoute
  SourcesIndexRoute: typeof SourcesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/subscriptions': {
      id: '/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof SubscriptionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/marketplace': {
      id: '/marketplace'
      path: '/marketplace'
      fullPath: '/marketplace'
      preLoaderRoute: typeof MarketplaceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bulk': {
      id: '/bulk'
      path: '/bulk'
      fullPath: '/bulk'
      preLoaderRoute: typeof BulkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/api': {
      id: '/api'
      path: '/api'
      fullPath: '/api'
      preLoaderRoute: typeof ApiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account': {
      id: '/account'
      path: '/account'
      fullPath: '/account'
      preLoaderRoute: typeof AccountRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sources/': {
      id: '/sources/'
      path: '/sources'
      fullPath: '/sources'
      preLoaderRoute: typeof SourcesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/': {
      id: '/collections/'
      path: '/collections'
      fullPath: '/collections'
      preLoaderRoute: typeof CollectionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sources/$sourceId': {
      id: '/sources/$sourceId'
      path: '/sources/$sourceId'
      fullPath: '/sources/$sourceId'
      preLoaderRoute: typeof SourcesSourceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/share/$token': {
      id: '/share/$token'
      path: '/share/$token'
      fullPath: '/share/$token'
      preLoaderRoute: typeof ShareTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resources/$resourceId': {
      id: '/resources/$resourceId'
      path: '/resources/$resourceId'
      fullPath: '/resources/$resourceId'
      preLoaderRoute: typeof ResourcesResourceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/collections/$collectionId': {
      id: '/collections/$collectionId'
      path: '/collections/$collectionId'
      fullPath: '/collections/$collectionId'
      preLoaderRoute: typeof CollectionsCollectionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/channels/$channelId': {
      id: '/channels/$channelId'
      path: '/channels/$channelId'
      fullPath: '/channels/$channelId'
      preLoaderRoute: typeof ChannelsChannelIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/signup': {
      id: '/_auth/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignupRoute: typeof AuthSignupRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignupRoute: AuthSignupRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AccountRoute: AccountRoute,
  ApiRoute: ApiRoute,
  BulkRoute: BulkRoute,
  DashboardRoute: DashboardRoute,
  HistoryRoute: HistoryRoute,
  MarketplaceRoute: MarketplaceRoute,
  ProfileRoute: ProfileRoute,
  SubscriptionsRoute: SubscriptionsRoute,
  ChannelsChannelIdRoute: ChannelsChannelIdRoute,
  CollectionsCollectionIdRoute: CollectionsCollectionIdRoute,
  ResourcesResourceIdRoute: ResourcesResourceIdRoute,
  ShareTokenRoute: ShareTokenRoute,
  SourcesSourceIdRoute: SourcesSourceIdRoute,
  CollectionsIndexRoute: CollectionsIndexRoute,
  SourcesIndexRoute: SourcesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
